import { Translations } from '../translations.type';

const zh: Translations = {
  lang: '中文',
  app_title: 'Mahjong BTI',
  app_subtitle: '麻将人格类型测试',
  app_description:
    '十六种麻将人格，十二道快问快答，看看牌桌上的你究竟是哪一型。',
  home_cta_start: '开始测试',
  home_footnote: '约 2 分钟 · 12 道题',

  wizard_progress: (current: number, total: number) =>
    `第 ${current} 题 / 共 ${total} 题`,
  wizard_prev: '上一题',
  wizard_next: '下一题',
  wizard_finish: '查看我的类型',
  wizard_pick_hint: '选一个最像你的答案',

  loading_messages: [
    '正在分析你的答案……',
    '正在解读牌河……',
    '正在数牌……',
    '正在确定你的牌桌人格……',
  ],

  result_title: '你是',
  result_subtitle: '你的麻将人格',
  result_retake: '重新测试',
  result_share: '分享',
  result_share_text: (code: string, name: string) =>
    `我是 ${code} —— ${name}。你的麻将人格是?`,
  result_axes_heading: '你的四个维度',

  share_button: '分享',
  share_title: '分享 Mahjong BTI',
  share_link_label: '链接',
  share_copy: '复制链接',
  share_copied: '已复制！',
  share_close: '关闭',
  share_scan_hint: '或扫描二维码',
  share_via: '分享到',
  share_native: '分享…',
  share_default_text: 'Mahjong BTI — 12 道题，测出你的麻将人格。',
  share_on: (network: string) => `分享到 ${network}`,

  footer_author: '作者',
  footer_source: '源码',

  axis_AD: '进攻 — 防守',
  axis_BS: '大牌 — 小胡',
  axis_CF: '理性 — 玄学',
  axis_TW: '严谨 — 随性',

  axis_AD_tagline: '风声一紧，你是往前冲，还是往后撤？',
  axis_BS_tagline: '一发烟花的高光，还是二十回稳稳的小确幸？',
  axis_CF_tagline: '是数据说了算，还是直觉拍板？',
  axis_TW_tagline: '一条道走到黑，还是兵来将挡水来土掩？',

  pole_A: '进攻',
  pole_D: '防守',
  pole_B: '大牌',
  pole_S: '小胡',
  pole_C: '理性',
  pole_F: '玄学',
  pole_T: '严谨',
  pole_W: '随性',

  pole_A_description:
    '听见洗牌声你眼睛就亮。手里的牌不是收藏品，是子弹，要一张张打出去——你是真心相信下一把就是你的。耐心？耐心是留给那些不相信自己手牌的人的。',
  pole_D_description:
    '你宁可一晚不胡，也绝不放炮。看牌河像看茶叶占卜，半成型的好牌该拆就拆，让别人去互相点炮，你稳坐钓鱼台——筹码不少，情绪不崩，第二天还能早起。',
  pole_B_description:
    '小胡你看不上眼。一手已经能胡的牌，你照样敢拆了重做，就为搏一把第二天还能在群里被人提起的大牌。要赢就要赢得发得了朋友圈，最好还能配一段获奖感言。',
  pole_S_description:
    '胡得小，胡得勤，胡得不停。你不需要烟花，要的是稳定的"我胡了"和一小摞越摞越高的筹码。反正分数簿不在乎一把多大，何必让自己加班？',
  pole_F_description:
    '有的牌看着就晦气，有的牌看着就友好，你也不再装作没感觉。你靠预感、靠氛围、靠那种说不清的"这张不行"在打牌，宇宙似乎也很配合。怀疑论者继续数牌，你继续胡牌就好。',
  pole_C_description:
    '牌河是数据，听牌是概率，整张桌子就是你正在求解的一张大表。你不信运气，你信长期收益——而长期收益平均下来也很爱你。方差只是天气，下完就过。',
  pole_T_description:
    '定下计划就跟它结婚。不冲动，不情绪化打牌，不深夜逞英雄。纪律听起来很无聊，等到数完筹码的那一刻，桌上最性感的东西就是它——只是没人会大声说出来。',
  pole_W_description:
    '计划只是参考，不是牢笼。势头来了就乘，风向变了就转，整张桌子的气氛带你飞。可预测？那不是你的人设——有时候连你自己都猜不到自己下一步要干嘛，乐趣也在这。',

  questions: {
    q1: {
      question: '第一巡刚开局，你摸到一张牌，你会想:',
      options: [
        '开整，先组组手里这副牌再说。',
        '先不急，看看别人都打什么。',
      ],
    },
    q2: {
      question: '有对手明显快听牌了，而且看着是一手大牌，你会:',
      options: [
        '抢在他前面胡，我的牌也不慢。',
        '改打防守，别给人放炮。',
      ],
    },
    q3: {
      question: '最后一巡你已经听牌了，但听的是危险牌，你会:',
      options: [
        '搏一搏，胡了再说。',
        '打张安全牌，不胡也别输。',
      ],
    },
    q4: {
      question: '你可以马上胡一个小牌，也可以拆掉做大牌，你会:',
      options: [
        '拆!大牌值得等。',
        '胡了!胡牌就是胡牌。',
      ],
    },
    q5: {
      question: '摸到一张能撑起一手大牌的关键牌，你会:',
      options: [
        '围着它做，这把得整一个大的。',
        '记住就好，该怎么打还怎么打。',
      ],
    },
    q6: {
      question: '你心目中的"理想麻将之夜"是:',
      options: [
        '一把大牌，发朋友圈那种。',
        '一晚胡 20 把，把把都是底分。',
      ],
    },
    q7: {
      question: '决定打哪张牌的时候，你主要靠:',
      options: [
        '数牌、看牌河、算概率。',
        '感觉，哪张牌"该打"我就知道。',
      ],
    },
    q8: {
      question: '连输了几把，你的处理办法是:',
      options: [
        '复盘一下，看看哪里出了问题。',
        '换个座位、洗个手、摸摸幸运符。',
      ],
    },
    q9: {
      question: '有人听的牌很怪，你会想:',
      options: [
        '"按概率算，安全牌是 X、Y、Z。"',
        '"这张牌感觉不对，先不打。"',
      ],
    },
    q10: {
      question: '开局你定了个套路，打到一半你会:',
      options: [
        '坚持计划，稳就是赢。',
        '随机应变，牌变我也变。',
      ],
    },
    q11: {
      question: '坐到牌桌前，你的目标是:',
      options: [
        '认真打，目标是赢。',
        '玩开心，赢了是惊喜。',
      ],
    },
    q12: {
      question: '连胡三把之后，你会:',
      options: [
        '保持原来的节奏，稳住别飘。',
        '飘一把，趁手气浪一把试试。',
      ],
    },
  },

  types: {
    ABCT: {
      name: '屠龙刀',
      tagline: '冷静、精确、致命 —— 桌上最让人怕的杀手。',
      description:
        '你的进攻像手术刀:每一打都算过，每一推都掐着点。出手就要见血，平时不动声色，一动手就让人心慌。',
    },
    ABCW: {
      name: '赌神附体',
      tagline: '大牌、大注、大场面。',
      description:
        '你打牌张扬，目标就是赢。你看得懂局势，知道什么时候该豪赌，豪赌起来眼都不眨一下，顺便还带点表演性。',
    },
    ABFT: {
      name: '莽夫流',
      tagline: '推、推、推，怕什么之后再说。',
      description:
        '耐心被高估了。你进攻凶猛，推得果断，凭直觉拉着自己往前冲。赢了豪情万丈，输了下一把再来。',
    },
    ABFW: {
      name: '玄学大师',
      tagline: '运气护体，玄学加持。',
      description:
        '你也进攻，但真正的策略是信。你凭感觉摸牌，宇宙好像还真就配合。别人说这是运气，你说这是缘分。',
    },
    ASCT: {
      name: '流水线工人',
      tagline: '见碰就碰，见胡就胡。',
      description:
        '效率高于美感。能碰就碰，能吃就吃，把一手又一手小牌干净利落地推进胡的终点——一遍又一遍。',
    },
    ASCW: {
      name: '速胡刺客',
      tagline: '第六张就听牌的极速派。',
      description:
        '你打得快。别人还在理牌，你已经在等胡了。也许胡得不大，但胡得早、胡得多。',
    },
    ASFT: {
      name: '见好就收',
      tagline: '小胡也是胡。',
      description:
        '你看得清局势，该收就收。不需要大场面，稳稳的小胜就够爽。知足，本身就是一种本事。',
    },
    ASFW: {
      name: '鸡胡之王',
      tagline: '一晚二十把，每把都是底分。',
      description:
        '你赢得勤，赢得开心。胡的大小不重要，重要的是"我胡了"。你是每个牌桌的吉祥物。',
    },
    DBCT: {
      name: '老六本六',
      tagline: '不胡，不放炮，最后还赢了。',
      description:
        '你像隐形人一样存在于牌桌。你不追胡，你只求活到最后。一晚下来，筹码不知不觉就堆到你这边，大家都搞不清你是怎么赢的。',
    },
    DBCW: {
      name: '反向操作',
      tagline: '守、守、守…突然一把猛攻!',
      description:
        '你前十巡稳如老狗，第十一巡突然推一把。反差是你的武器，别人刚摸清你的路数，你就翻脸了。',
    },
    DBFT: {
      name: '闷声发财',
      tagline: '话不多，牌很大。',
      description:
        '你不需要张扬。一旦报出来，牌就是大的。少一点声响，多一点宝牌——这就是你的风格。',
    },
    DBFW: {
      name: '佛系大佬',
      tagline: '胜负看缘分，缘分总在你这边。',
      description:
        '输赢都是浮云。你打得云淡风轻，该来的牌就来了。牌桌是你的禅堂，赢只是顺便。',
    },
    DSCT: {
      name: '计算器',
      tagline: '概率是你的浪漫。',
      description:
        '你知道每一种听的概率，记得每一张牌的去向，算得清每一步的期望值。也许单把不一定赢，但长期下来你稳稳领先。',
    },
    DSCW: {
      name: '小心翼翼浪',
      tagline: '先算账，再放胆。',
      description:
        '你想冒险，真的想，但得先把概率算清楚。结果就是你打得既小心又偶尔惊人，连你自己都会被自己的操作吓一跳。',
    },
    DSFT: {
      name: '安全第一',
      tagline: '防守也是一种完整的策略。',
      description:
        '你的目标很简单:不放炮。能弃就弃，能拆就拆，让风暴从你身边过去。别人都输钱而你没输，你已经赢了。',
    },
    DSFW: {
      name: '划水冠军',
      tagline: '我是来吃零食的，顺便打几把。',
      description:
        '麻将是配菜，朋友才是主菜。你打得松散、笑得很多，完全不在乎分数。说真的，这也是一种境界。',
    },
  },
};

export default zh;
